import React, { useState } from 'react';
import { Tabs } from 'antd';
import DisplayImageType from '../Organism/DisplayImageTypes'
import DisplayImageCategory from '../Organism/DisplayImageCategory';
import DisplayImageSubCategory from '../Organism/DisplayImageSubCategory';

const ImagePages: React.FC = () => {
  const [activeKey, setActiveKey] = useState('1');

  const onTabChange = (key: string) => {
    setActiveKey(key);
  };

   return (
    <Tabs activeKey={activeKey} onChange={onTabChange}>
      <Tabs.TabPane tab="Image Type" key="1">
        <DisplayImageType />       
      </Tabs.TabPane>
      <Tabs.TabPane tab="Image Category" key="2">
        <DisplayImageCategory />
      </Tabs.TabPane>
      <Tabs.TabPane tab="Image Sub Category" key="3">
        <DisplayImageSubCategory />
      </Tabs.TabPane>
    </Tabs>
  );
};

export default ImagePages;